import { useEffect, useRef } from 'react';

export function useBackButton(isOpen: boolean, onClose: () => void) {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;

    // Push dummy state to intercept the back button
    window.history.pushState({ modalOpen: true }, '', window.location.href);

    const handlePopState = (event: PopStateEvent) => {
      onCloseRef.current();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      // We intentionally do NOT call window.history.back() here.
      // Calling history.back() in a cleanup function conflicts with React Strict Mode 
      // which does an automatic unmount-remount cycle, causing the modal to close instantly.
    };
  }, [isOpen]);
}
